import { render } from "./MisReport.vue?vue&type=template&id=066f2caa&scoped=true"
import script from "./MisReport.vue?vue&type=script&lang=js"
export * from "./MisReport.vue?vue&type=script&lang=js"

import "./MisReport.vue?vue&type=style&index=0&id=066f2caa&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Leads\\leads-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-066f2caa"]])

export default __exports__